/* The complete description is server-rendered once. Move only an opening paragraph before any heading. */
(() => {
  if (customElements.get('andcharlie-product-description')) return;
  const text = (node) => node.textContent.replace(/[\s\u00a0\u200b-\u200d\ufeff]+/gu, '').trim();
  const media = 'img,picture,video,audio,svg,iframe,object,embed,table,hr,input,select,textarea,button';

  class AndCharlieProductDescription extends HTMLElement {
    connectedCallback() {
      this.initializeBound ||= () => this.initialize();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.initializeBound, { once: true });
      else this.initialize();
    }

    disconnectedCallback() { document.removeEventListener('DOMContentLoaded', this.initializeBound); }

    initialize() {
      if (this.initialized || !this.isConnected) return;
      const source = this.querySelector('[data-ac-content-source]');
      if (!source) return;
      this.initialized = true;
      this.dataset.acDescriptionState = 'whole';
      if (this.dataset.contentSource !== 'description') return;
      const lead = Array.from(this.closest('product-info')?.querySelectorAll('[data-ac-product-lead]') || [])
        .find((node) => node.dataset.productId === this.dataset.productId);
      if (!lead || text(lead) || lead.querySelector(media)) return;
      const paragraph = Array.from(source.querySelectorAll('p')).find((node) => text(node) && !node.closest('[hidden], [aria-hidden="true"]'));
      if (!paragraph) return;
      // A paragraph after a heading belongs to that section, even inside an old DIV wrapper.
      // Moving it would leave the heading behind with no explanation.
      if (Array.from(source.querySelectorAll('h1,h2,h3,h4,h5,h6'))
        .some((heading) => heading.compareDocumentPosition(paragraph) & Node.DOCUMENT_POSITION_FOLLOWING)) return;
      // Never pull a paragraph out of a list, table, quote or semantic container.
      // Old neutral DIV wrappers may remain; the remaining HTML is never reconstructed.
      for (let parent = paragraph.parentElement; parent !== source; parent = parent.parentElement) {
        if (parent.tagName !== 'DIV' || parent.matches('[id],[role],[aria-label],[aria-labelledby],[aria-describedby],[itemscope]')) return;
      }
      lead.append(paragraph);
      lead.hidden = false;
      const about = source.closest('[data-ac-content-section="about"]');
      if (about) about.hidden = !text(source) && !source.querySelector(media);
      this.dataset.acDescriptionState = 'split';
    }
  }
  customElements.define('andcharlie-product-description', AndCharlieProductDescription);
})();
